// import React from "react";
// import classNames from "./classNames";

// const noop = () => {};
// const defaultProps = {
//   loadOptions: noop,
//   onChange: noop,
//   onSearch: noop,
//   onClickAdd: noop,
//   onClickClear: noop,
//   onFocus: noop,
//   value: { label: "", value: "" },
//   placeholder: "Select",
//   dynamic: false,
// };

// function SelectSearch({
//   className,
//   value,
//   placeholder,
//   onChange,
//   onSearch,
//   onClickAdd,
//   onClickClear,
//   onFocus,
//   focus,
//   options,
//   required,
//   dynamic,
// }) {
//   const [search, setSearch] = React.useState("");
//   const [text, setText] = React.useState("");
//   const [isOpen, setOpen] = React.useState(false);
//   const ref = React.useRef(null);

//   console.log("options", options);
//   console.log("value", value);

//   // handle click outside event
//   const handleClickOutside = (event) => {
//     if (ref.current && !ref.current.contains(event.target)) {
//       setOpen(false);
//       onFocus(false);
//     }
//   };

//   React.useEffect(() => {
//     // add when mounted
//     document.addEventListener("mousedown", handleClickOutside);
//     // return function to be called when unmounted
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);
//   // when value change
//   React.useEffect(() => {
//     setText(value.label);
//     setSearch("");
//   }, [value]);

//   function _onChange(e) {
//     // Get the new character input by the user by removing the previous text from the current value.
//     const character = e.target.value.replace(text, "");
//     if (search === "") {
//       e.target.value = character;
//     }
//     // set the new character input by the user
//     setSearch(e.target.value);
//     setText(e.target.value);
//     onSearch(e.target.value);
//   }

//   // function onClick(e) {
//   //   // e.target.setSelectionRange(0, 0);
//   //   if (!isOpen) {
//   //     e.target.blur();
//   //   }
//   //   setOpen(!isOpen || focus);
//   // }

//   function onSelect(value, index) {
//     console.log("value", value, "index", index);
//     onChange(value, index);
//     setText(value);
//     setOpen(false);
//     if (search) {
//       // reset the options if has search
//       onSearch("");
//     }
//   }

//   // function _onFocus(e) {
//   //   if (!focus) {
//   //     e.target.blur();
//   //   }
//   //   onFocus(true);
//   // }

//   function onClickIcon(e) {
//     if (text) {
//       onClickClear(e);
//     } else if (dynamic) {
//       onClickAdd(e);
//     } else {
//       // onClick(e);
//     }
//   }

//   const style = { cursor: isOpen && focus ? "text" : "default" };
//   const icon = text ? "bi bi-x" : dynamic ? "bi bi-plus" : "bi bi-chevron-down";
//   return (
//     <div ref={ref} style={{ position: "relative" }}>
//       <div className="input-group">
//         {/* <input
//           // onClick={onClick}
//           type="text"
//           // className={classNames(className, "form-control border-end-0 pe-0")}
//           // placeholder={placeholder}
//           value={text}
//           onChange={_onChange}
//           // onFocus={_onFocus}
//         /> */}
//         {/* <button onClick={onClickIcon} className="btn btn-link" type="button">
//           <i className={icon}></i>
//         </button> */}
//       </div>
//       <div className="d-flex flex-wrap gap-2">
//         {options.map((option, index) => {
//           console.log("option map", option, "value map", value);
//           const isSelected = option.value === value.value;

//           console.log("isSelected", isSelected);
//           const colorClass = option.colorClass || "btn-secondary";

//           return (
//             <button
//               key={option.value}
//               type="button"
//               className={`btn text-nowrap shadow-sm ${colorClass} ${isSelected ? "active" : ""}`}
//               onClick={() => onSelect(option, index)}
//             >
//               {option.label}
//             </button>
//           );
//         })}
//       </div>
//       {/* {isOpen && (
//         <ul
//           className="list-group rounded-0 bg-white"
//           style={{
//             position: "absolute",
//             top: "100%",
//             width: "100%",
//             maxHeight: "200px",
//             overflowY: "auto",
//             zIndex: 1000,
//           }}
//         >
//           {options.map((option, index) => (
//             <li
//               key={option.value}
//               type="button"
//               className="list-group-item list-group-item-action"
//               onClick={() => onSelect(option, index)}
//             >
//               {option.label}
//             </li>
//           ))}
//         </ul>
//       )} */}
//     </div>
//   );
// }

// SelectSearch.defaultProps = defaultProps;
// export default SelectSearch;

import React from "react";
import classNames from "./classNames";

const noop = () => {};

const defaultProps = {
  onChange: noop,
  value: { label: "", value: "" },
  options: [],
};

function SelectSearch({ className, value, onChange, options }) {
  function onSelect(option, index) {
    onChange(option, index);
  }

  return (
    <div className={classNames(className)}>
      <div className="d-flex flex-wrap gap-2">
        {options.map((option, index) => {
          const isSelected = option.value === value?.value;

          return (
            <button
              key={`${option.value}-${index}`}
              type="button"
              className={`btn text-nowrap shadow-sm px-4 py-3 ${
                isSelected
                  ? "bg-info text-white border border-info"
                  : "bg-white text-dark border"
              }`}
              onClick={() => onSelect(option, index)}
              style={{
                minWidth: "110px",
                borderRadius: "14px",
              }}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

SelectSearch.defaultProps = defaultProps;

export default SelectSearch;
